(function(){
     'use strict';

     angular
        .module('app')
        .factory('FotosService', FotosService);

    FotosService.$inject = ['$http'];

    function FotosService($http){


        var service= {
            getListaFotos: getListaFotos,
            getServidorFotos: getServidorFotos,
            cropearFoto:cropearFoto,
            getInfoFoto:getInfoFoto,
            saveInfo:saveInfo,
            nuevaCarpeta:nuevaCarpeta,
            updateCarpeta:updateCarpeta,
            refreshList:refreshList,
            moverCarpeta:moverCarpeta,
            borrarFotoServer:borrarFotoServer
        };

        return service;

        function getListaFotos(id,crop,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                id: id,
                crop:crop
            });
            $http.post("/backend/altcrm/foto/listadefotos", data, config)
            .success(getFotoSuccess)
            .error(getFotoFailed);
            function getFotoSuccess(data){ 
                callback(data);
            }
            function getFotoFailed(data){
                
                return false;
            }
        }

        function refreshList(buscar,vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                buscar:buscar,
                ids:vm.value,
                pagina:vm.pagina
            });
            $http.post("/backend/altcrm/foto/listaservidor", data, config)
            .success(getFotoSuccess)
            .error(getFotoFailed);
            function getFotoSuccess(data){ 
                callback(data);
            }
            function getFotoFailed(data){
                
                return false;
            }
        }
        

        function borrarFotoServer(foto,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                foto:foto
            });
            $http.post("/backend/altcrm/foto/borrarfotoserver", data, config)
            .success(getFotoSuccess)
            .error(getFotoFailed);
            function getFotoSuccess(data){ 
                callback(data);
            }
            function getFotoFailed(data){
                
                return false;
            }
        }

        function moverCarpeta(carpetaOrigen,carpetaDestino,indexDestino,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                carpetaOrigen:carpetaOrigen,
                carpetaDestino: carpetaDestino,
                indexDestino:indexDestino
            });
            $http.post("/backend/altcrm/foto/movercarpeta", data, config)
            .success(getFotoSuccess)
            .error(getFotoFailed);
            function getFotoSuccess(data){ 
                callback(data);
            }
            function getFotoFailed(data){
                
                return false;
            }
        }
        function saveInfo(foto,vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                foto: foto,
                lang_id:vm.lang_id
            });
            $http.post("/backend/altcrm/foto/saveinfo", data, config)
            .success(getFotoSuccess)
            .error(getFotoFailed);
            function getFotoSuccess(data){ 
                callback(data);
            }
            function getFotoFailed(data){
                
                return false;
            }
        }

        function updateCarpeta(carpeta,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                carpeta: carpeta
            });
            $http.post("/backend/altcrm/foto/updatecarpeta", data, config)
            .success(getFotoSuccess)
            .error(getFotoFailed);
            function getFotoSuccess(data){ 
                callback(data);
            }
            function getFotoFailed(data){
                
                return false;
            }
        }

        function nuevaCarpeta(carpetaPadre,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                carpetaPadre: carpetaPadre
            });
            $http.post("/backend/altcrm/foto/nuevacarpeta", data, config)
            .success(getFotoSuccess)
            .error(getFotoFailed);
            function getFotoSuccess(data){ 
                callback(data);
            }
            function getFotoFailed(data){
                
                return false;
            }
        }

        function getInfoFoto(foto,vm,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                foto: foto,
                lang_id:vm.lang_id,
                crop:vm.sizes
            });
            $http.post("/backend/altcrm/foto/getinfo", data, config)
            .success(getFotoSuccess)
            .error(getFotoFailed);
            function getFotoSuccess(data){ 
                callback(data);
            }
            function getFotoFailed(data){
                return false;
            }
        }

        function getServidorFotos(vm,buscar,callback){
        	var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                ids: vm.value,
                pagina:vm.pagina,
                idFolder:vm.folderSeleccionada,
                buscar:buscar
            });
            $http.post("/backend/altcrm/foto/listaservidor", data, config)
            .success(getFotoSuccess)
            .error(getFotoFailed);
            function getFotoSuccess(data){ 
                callback(data);
            }
            function getFotoFailed(data){
                
                return false;
            }
        }

        function cropearFoto(foto,cropCords,callback){

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                id:foto.file_id,
               path:foto.file_path, 
               crop:cropCords,
               width: foto.width, 
               height: foto.height 
            });
            $http.post("/backend/altcrm/foto/crop", data, config)
            .success(getFotoSuccess)
            .error(getFotoFailed);
            function getFotoSuccess(data){ 
                callback(data);
            }
            function getFotoFailed(data){
                
                return false;
            }
        }
        
    }
})();